const constantType = {
  START_FETCHING_CONSTANT: "START_FETCHING_CONSTANT",
  SUCCESS_FETCHIED_CONSTANT: "SUCCESS_FETCHIED_CONSTANT",
  FAILURE_FETCHED_CONSTANT: "FAILURE_FETCHED_CONSTANT",
};

export default constantType;
